export default {
    install(Vue) {
        Vue.mixin({
            data(){
                return {
                    clickBtuuonRepeat: false,
                    isShowArr: ['rj.njjhykj.com'],
                    isShowArrData:[
                        {url:'rj.njjhykj.com',lxr:'陈老师',phone:'15026448220',site:'江苏省南京市浦口区桥林街道西街湾6号1幢104室-10',name:'南京聚华游网络科技有限公司'},
                    ],
                    footerCompany: ['rj.njjhykj.com'],
                    matchHostArr : [
                        { host: 'rj.njjhykj.com', name: '南京聚华游网络科技有限公司' },
                      ],
                }
            },
            methods:{

                //将url转成对象
                parseQueryString(url) {
                    //url参数转对象
                    url = !url ? window.location.href : url
                    if (url.indexOf('?') === -1) {
                    return null
                    }
                    let search = url[0] === '?' ? url.substr(1) : url.substring(url.lastIndexOf('?') + 1)
                    if (search === '') {
                    return null
                    }
                    search = search.split('&')
                    let query = {}
                    for (let i = 0; i < search.length; i++) {
                    let pair = search[i].split('=')
                    // query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
                    query[pair[0]] = pair[1] || ''
                    }
                    return query
                },

                isToPdf(){

                }
            }
        })
    }
}